import { Pipe, PipeTransform } from '@angular/core';
import { DateUtility } from '@jms/model';
import { DateTime } from 'luxon';

@Pipe({
  name: 'timeSimple',
  standalone: true
})
export class TimeSimplePipe implements PipeTransform {

  transform(value: Date | DateTime | string, timezone: string): string {

    if (!value)
      return '';

    value = typeof value === 'string'
      ? DateUtility.getDateTime(value, timezone)
      : value;

    return value.toLocaleString(DateTime.TIME_24_SIMPLE);
  }

}
